import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  FiUserCheck,
  FiEdit,
  FiAlertCircle,
  FiHelpCircle,
} from "react-icons/fi";

const stats = [
  {
    title: "Total Present",
    value: "180/200",
    bg: "/assets/img/bg/bg-green-01.svg",
    icon: <FiUserCheck />,
    color: "#22c55e",
  },
  {
    title: "Planned Leaves",
    value: "10",
    bg: "/assets/img/bg/bg-pink-01.svg",
    icon: <FiEdit />,
    color: "#ec4899",
  },
  {
    title: "Unplanned Leaves",
    value: "10",
    bg: "/assets/img/bg/bg-yellow-01.svg",
    icon: <FiAlertCircle />,
    color: "#f59e0b",
  },
  {
    title: "Pending Requests",
    value: "15",
    bg: "/assets/img/bg/bg-blue-01.svg",
    icon: <FiHelpCircle />,
    color: "#06b6d4",
  },
];

const LeavesStats = () => {
  return (
    <Row className="g-3">
      {stats.map((item, index) => (
        <Col xl={3} md={6} sm={12} key={index}>
          <Card
            style={{
              borderRadius: "6px",
              border: "1px solid #e5e7eb",
              height: "110px",
              overflow: "hidden",
              position: "relative",
              backgroundColor: "#fff",
              backgroundImage: `url(${item.bg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "auto 100%",
              backgroundPosition: "left center",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            }}
          >
            <Card.Body
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "14px 18px",
              }}
            >
              {/* ICON */}
              <div
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: item.color,
                  fontSize: "20px",
                  marginLeft: "12px", // IMPORTANT alignment
                  zIndex: 2,
                }}
              >
                {item.icon}
              </div>

              {/* TEXT */}
              <div
                style={{
                  textAlign: "right",
                  paddingRight: "4px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#6b7280",
                    marginBottom: "4px",
                  }}
                >
                  {item.title}
                </p>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#111827",
                  }}
                >
                  {item.value}
                </h4>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}

      {/* MOBILE FIX */}
      <style>
        {`
        @media (max-width: 768px) {
          .card {
            height: 95px !important;
          }
        }
        `}
      </style>
    </Row>
  );
};

export default LeavesStats;